var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content_box" },
    [
      _c(
        "v-snackbar",
        {
          attrs: { top: "", center: "", timeout: 10000, color: _vm.errorColor },
          model: {
            value: _vm.ipWhitelistApiFailed,
            callback: function($$v) {
              _vm.ipWhitelistApiFailed = $$v
            },
            expression: "ipWhitelistApiFailed"
          }
        },
        [
          _c("v-icon", { attrs: { dark: "" } }, [_vm._v("warning")]),
          _vm._v("   \n        "),
          _c("span", [_vm._v("Api failed")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "black--text snackbar-button",
              attrs: { color: _vm.errorColor, flat: "" },
              on: {
                click: function($event) {
                  _vm.ipWhitelistApiFailed = null
                  _vm.ipWhitelistApiFailed = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "settings_panel_card", attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "settings_toolbar", attrs: { flat: "", dense: "" } },
            [
              _c("v-toolbar-title", { staticClass: "settings_panel_heading" }, [
                _vm._v("IP whitelist")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { depressed: "", icon: "", small: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      class: _vm.showByDefaultAdd ? "" : "disabled",
                      attrs: { id: "addIPToList" },
                      on: {
                        click: function($event) {
                          return _vm.addRowIpwhiteList()
                        }
                      }
                    },
                    [_vm._v("add")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "apps_table_div" }, [
            _c("table", { staticClass: "apps_component_table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("IP")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("last Used")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Actions")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.getIpwhitelistResponseData, function(
                    items,
                    index
                  ) {
                    return _c("tr", { key: items["lastUse"] + index }, [
                      _c(
                        "td",
                        { staticClass: "alignment_for_data" },
                        [
                          _c("v-icon", { staticClass: "purple--text" }, [
                            _vm._v("language")
                          ]),
                          _vm._v(
                            " \n                        " +
                              _vm._s(items.ip || "xxxx:xx:xx:xx:xx") +
                              "\n                    "
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "alignment_for_data" }, [
                        _vm._v(_vm._s(items.lastUse || "0000:00:00"))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "ip_actions " }, [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons delete",
                            class:
                              _vm.getIpwhitelistResponseData.length == 1
                                ? "lastIp"
                                : "",
                            attrs: { id: "deleteIP" },
                            on: {
                              click: function($event) {
                                return _vm.saveOrDeleteRow(
                                  index,
                                  items,
                                  "delete"
                                )
                              }
                            }
                          },
                          [_vm._v("delete")]
                        )
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.ipwhitelistTableRow, function(row, index) {
                    return _c("tr", { key: index }, [
                      _vm.addrowDataIpwhitelist && index == _vm.newIndex
                        ? _c("td", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.ipwhitelistDefaultIp.ip,
                                  expression: "ipwhitelistDefaultIp.ip"
                                }
                              ],
                              staticClass: "apps_tableRow",
                              class: _vm.invalidIPRange ? "error-text" : "",
                              attrs: { type: "text", id: "addIP" },
                              domProps: { value: _vm.ipwhitelistDefaultIp.ip },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.ipwhitelistDefaultIp,
                                    "ip",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("td"),
                      _vm._v(" "),
                      _c("td", { staticClass: "action_icons" }, [
                        _vm.addrowDataIpwhitelist && index == _vm.newIndex
                          ? _c(
                              "i",
                              {
                                staticClass:
                                  "material-icons check_circle_outline access-token__icons",
                                class: _vm.invalidIPRange ? "disabled" : "",
                                on: {
                                  click: function($event) {
                                    return _vm.saveOrDeleteRow(
                                      index,
                                      "ipWhitelist",
                                      "save"
                                    )
                                  }
                                }
                              },
                              [_vm._v("check_circle_outline")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.addrowDataIpwhitelist && index == _vm.newIndex
                          ? _c(
                              "i",
                              {
                                staticClass:
                                  "material-icons highlight_off access-token__icons",
                                on: {
                                  click: function($event) {
                                    return _vm.closeRowIntables("ipwhitelist")
                                  }
                                }
                              },
                              [_vm._v("highlight_off")]
                            )
                          : _vm._e()
                      ])
                    ])
                  })
                ],
                2
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }